import React, { useCallback } from "react";
import { Result, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const SomeThingWentWrong = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const redirectCreateOrder = useCallback(() => {
    navigate(`/home/create-order`, {
      state: { from: location },
    });
  }, [navigate, location]);

  return (
    <React.Fragment>
      <Result
        status="error"
        title="Order Creation Failed"
        subTitle="Sorry, something went wrong."
        extra={[
          <Button key="create" onClick={redirectCreateOrder}>
            Try Again
          </Button>,
        ]}
      />
    </React.Fragment>
  );
};

export default SomeThingWentWrong;
